module.exports = __webpack_public_path__ + "img/fileupload.d1302458.svg";